import { Component, input } from "@angular/core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";
import { SearchViewOptionsFilterModel } from "../search-filter-view-options.model";

@Component({
    selector: "market-statistics-helper",
    templateUrl: "./market-statistics-helper.component.html",
    styleUrl: "./market-statistics-helper.component.scss",
})
export class MarketStatisticsHelperComponent {
    searchViewOptions = input.required<SearchViewOptionsFilterModel>();

    periodType = PeriodDefinitionType;
}
